import { useEffect, useState, Fragment, useRef } from "react";
import { Row, Card, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import moment from "moment";
import Steps, { Step } from "rc-steps"; //https://github.com/react-component/steps
import "rc-steps/assets/index.css";
import useFullPageLoader from "../../../hooks/useFullPageLoader";

import PageTitle from "../../layouts/PageTitle";
import OrderDatatable from "./_OrderDatatable";
import { fDate12US } from "../../../utils/formatTime";
import { clientActions, orderActions } from "../../../_store";

import html2pdf from "html2pdf.js";

const ViewOrder = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [htmlContent, setHtmlContent] = useState("");
  // const { pdfDataUri, generatePDF } = useHTMLToPDF();
  const horizontalIcons = {
    finish: <i className="fa fa-solid fa-shipping-fast"></i>,
    error: <i className="fa fa-solid fas fa-clock"></i>,
  };

  const verticalIcons = {
    finish: <i className="fa fa-solid fas fa-history"></i>,
  };
  const listView = location.state;
  // #region ------------------  Reducer --------------------------------
  const orderClient = useSelector((x) => x.client.client);
  const orderStatusHistoryUniqueList = useSelector(
    (x) => x.order.orderStatusHistoryUniqueList,
  );
  const enumOrderStatus = useSelector((x) => x.order.enumOrderStatus);
  const isLoading = useSelector((x) => x.order.isLoading);

  const orderDetail = useSelector((state) => state.order.orderDetail);

  // #endregion ------------------  Reducer End --------------------------------
  const [state, setState] = useState({});
  const [orderTrackingHORZ, setorderTrackingHORZ] = useState({
    CreatedStatus: "finish",
    AssignedStatus: "process",
    PreparedStatus: "wait",
    InvoiceSentStatus: "wait",
    PaymentReceivedStatus: "wait",
    ReadyToDispatchStatus: "wait",
    OrderDispatchedStatus: "wait",
  });

  const trackingHORZ = { ...orderTrackingHORZ };

  useEffect(() => {
    showLoader();
    dispatch(
      orderActions.GetOrderStatusHistoryUniqueByOrderID(listView.OrderID),
    );
    dispatch(clientActions.getClientById(listView.ClientID));
  }, []);

  // order Status History order tracking calculation
  useEffect(() => {
    if (
      orderStatusHistoryUniqueList &&
      orderStatusHistoryUniqueList.length > 0
    ) {
      if (
        listView.OrderStatusID === enumOrderStatus.Cancelled ||
        listView.OrderStatusID === enumOrderStatus.Refund
      ) {
        trackingHORZ.CreatedStatus = "wait";
        trackingHORZ.AssignedStatus = "wait";
        trackingHORZ.PreparedStatus = "wait";
        trackingHORZ.InvoiceSentStatus = "wait";
        trackingHORZ.PaymentReceivedStatus = "wait";
        trackingHORZ.ReadyToDispatchStatus = "wait";
        trackingHORZ.OrderDispatchedStatus = "wait";
      } else {
        // let CurrentDate = moment(new Date());
        let CreatedDateStr = orderStatusHistoryUniqueList.find(
          ({ OrderStatus }) => OrderStatus === enumOrderStatus.OrderCreated,
        )?.CreatedDate;
        let CreatedDate = moment(new Date(CreatedDateStr && CreatedDateStr));

        // check Order Assigned
        if (listView.OrderStatusID > enumOrderStatus.OrderCreated) {
          let OACompletedMinutes = 1440; //24 Hrs

          let AssignedDateStr = orderStatusHistoryUniqueList.find(
            ({ OrderStatus }) => OrderStatus === enumOrderStatus.OrderAssigned,
          )?.CreatedDate;
          let AssignedDate = moment(
            new Date(AssignedDateStr && AssignedDateStr),
          );

          let minutes = AssignedDate.diff(CreatedDate, "minutes");
          if (OACompletedMinutes < minutes) {
            trackingHORZ.AssignedStatus = "error";
          } else {
            trackingHORZ.AssignedStatus = "finish";
          }
        } else {
          trackingHORZ.AssignedStatus = "process";
        }

        // check Order Prepared
        try {
          if (listView.OrderStatusID > enumOrderStatus.OrderAssigned) {
            let OPCompletedMinutes = 3600; // 60 Hrs
            let PreparedDateStr = orderStatusHistoryUniqueList.find(
              ({ OrderStatus }) =>
                OrderStatus === enumOrderStatus.OrderPrepared,
            )?.CreatedDate;
            let PreparedDate = moment(new Date(PreparedDateStr));
            let minutes = PreparedDate.diff(CreatedDate, "minutes");
            if (OPCompletedMinutes < minutes) {
              trackingHORZ.PreparedStatus = "error";
            } else {
              trackingHORZ.PreparedStatus = "finish";
            }
          } else if (listView.OrderStatusID === enumOrderStatus.OrderAssigned) {
            trackingHORZ.PreparedStatus = "process";
          }
        } catch {}

        // check Order Invoice Sent
        try {
          if (listView.OrderStatusID > enumOrderStatus.OrderPrepared) {
            let ISCompletedMinutes = 4320; // 72 Hrs
            let InvoiceSentDateStr = orderStatusHistoryUniqueList.find(
              ({ OrderStatus }) => OrderStatus === enumOrderStatus.InvoiceSent,
            )?.CreatedDate;
            let InvoiceSentDate = moment(new Date(InvoiceSentDateStr));
            let minutes = InvoiceSentDate.diff(CreatedDate, "minutes");
            if (ISCompletedMinutes < minutes) {
              trackingHORZ.InvoiceSentStatus = "error";
            } else {
              trackingHORZ.InvoiceSentStatus = "finish";
            }
          } else if (listView.OrderStatusID === enumOrderStatus.OrderPrepared) {
            trackingHORZ.InvoiceSentStatus = "process";
          }
        } catch {}

        //check Order Payment Received

        if (listView.OrderStatusID >= enumOrderStatus.PaymentReceived) {
          trackingHORZ.PaymentReceivedStatus = "finish";
        } else if (listView.OrderStatusID === enumOrderStatus.InvoiceSent) {
          trackingHORZ.PaymentReceivedStatus = "process";
        }

        //check Order Ready To Dispatch
        if (listView.OrderStatusID >= enumOrderStatus.ReadyToDispatch) {
          trackingHORZ.ReadyToDispatchStatus = "finish";
        } else if (listView.OrderStatusID === enumOrderStatus.PaymentReceived) {
          trackingHORZ.ReadyToDispatchStatus = "process";
        }

        //check Order Dispatched
        if (listView.OrderStatusID >= enumOrderStatus.OrderDispatched) {
          trackingHORZ.OrderDispatchedStatus = "finish";
        } else if (listView.OrderStatusID === enumOrderStatus.ReadyToDispatch) {
          trackingHORZ.OrderDispatchedStatus = "process";
        }
      }

      setorderTrackingHORZ(trackingHORZ);
    }
  }, [orderStatusHistoryUniqueList]);

  //Address (billing,shipping) Load
  useEffect(() => {
    if (
      orderClient.ShippingAddressModelList &&
      orderClient.ShippingAddressModelList.length === 1
    ) {
      let { ShippingAddress, ShippingCity, CountryName } =
        orderClient.ShippingAddressModelList[0];
      setState({ ShippingAddress, ShippingCity, CountryName });
    } else if (
      orderClient.ShippingAddressModelList &&
      orderClient.ShippingAddressModelList.length > 1
    ) {
      let res = orderClient.ShippingAddressModelList.filter(
        (obj) => obj.IsDefault === true,
      );
      if (res.length === 1) {
        let resp = orderClient.ShippingAddressModelList.filter(
          (obj) => obj.IsDefault === true,
        );

        let { ShippingAddress, ShippingCity, CountryName } = resp[0];
        setState({ ShippingAddress, ShippingCity, CountryName });
      } else {
        let resp = orderClient.ShippingAddressModelList;
        let len = resp.length - 1;
        let { ShippingAddress, ShippingCity, CountryName } = resp[len];
        setState({ ShippingAddress, ShippingCity, CountryName });
      }
    } else {
      setState((perv) => {
        return {
          ...perv,
          ShippingAddress: "",
          ShippingCity: "",
          CountryName: "",
        };
      });
    }
  }, [orderClient && orderClient.ShippingAddressModelList]);

  const handlechanges = () => {
    navigate(listView?.previousPage ? listView?.previousPage : "/OrderList");
  };

  useEffect(() => {
    if (isLoading) {
      hideLoader();
    }
  }, [isLoading]);

  // let bodyHtml = (
  //   <div className="row">
  //     <div className="col-xl-12 col-xxl-12">
  //       <div className="card">
  //         <div className="card-body">
  //           <Steps
  //             direction="horizontal"
  //             size="large"
  //             type="inline"
  //             icons={horizontalIcons}
  //             labelPlacement="vertical"
  //           >
  //             <Step
  //               title="Order Created"
  //               description=""
  //               status={orderTrackingHORZ.CreatedStatus}
  //             />
  //             <Step
  //               title="Order Assigned"
  //               description=" "
  //               status={orderTrackingHORZ.AssignedStatus}
  //             />

  //             <Step
  //               title="Order Prepared"
  //               status={orderTrackingHORZ.PreparedStatus}
  //               description=""
  //             />

  //             <Step
  //               title="Invoice Sent"
  //               status={orderTrackingHORZ.InvoiceSentStatus}
  //               description=""
  //             />
  //             <Step
  //               title="Payment Received"
  //               status={orderTrackingHORZ.PaymentReceivedStatus}
  //               description=""
  //             />
  //             <Step
  //               title="Ready to Dispatch"
  //               status={orderTrackingHORZ.ReadyToDispatchStatus}
  //               description=""
  //             />
  //             <Step
  //               title="Order Dispatched"
  //               status={orderTrackingHORZ.OrderDispatchedStatus}
  //               description=""
  //             />
  //           </Steps>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );

  //const [pdfDataUri, setPdfDataUri] = useState(null);

  //  const generatePDF = (htmlContent, options = {}) => {
  //
  //     const defaultOptions = {
  //       margin: 1,
  //       filename: "document.pdf",
  //       image: { type: "jpeg", quality: 0.98 },
  //       html2canvas: { scale: 2 },
  //       jsPDF: { unit: "in", format: "letter", orientation: "landscape" },
  //       ...options,
  //     };

  //     html2pdf()
  //       .from(htmlContent)
  //       .set(defaultOptions)
  //       .toPdf()
  //       .get("pdf")
  //       .then((pdf) => {
  //
  //         const dataUri = pdf.output("datauristring");
  //         setPdfDataUri(dataUri);
  //       });

  //     return { pdfDataUri, generatePDF };
  //   };

  const contentRef = useRef(null);

  const generatePDF = async () => {
    showLoader();
    let scaleVal = 2;
    if (
      orderDetail?.OrderProductModelList?.length > 100 &&
      orderDetail?.OrderProductModelList?.length < 301
    ) {
      scaleVal = 1.5;
    } else if (
      orderDetail?.OrderProductModelList?.length > 300 &&
      orderDetail?.OrderProductModelList?.length < 601
    ) {
      scaleVal = 0.9;
    } else if (orderDetail?.OrderProductModelList?.length > 600) {
      scaleVal = 0.6;
    }

    const element = contentRef.current;
    const defaultOptions = {
      margin: 0.3,
      filename: "document.pdf",
      image: { type: "jpeg", quality: 0.98 },
      pagebreak: {
        avoid: "tr",
        mode: "avoid-all",
        before: "#nextpage1",
      },
      html2canvas: {
        scale: scaleVal,
        useCORS: true,
        letterRendering: true,
        dpi: 192,
      },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
    };

    // Set a delay to batch the rendering and avoid memory overload

    await html2pdf()
      .set(defaultOptions)
      .from(element)
      .toPdf()
      .get("pdf")
      .then(function (pdf) {
        pdf.setFontSize(7); // Adjust font size
      })
      .save("View_Order.pdf");

    hideLoader();
  };

  return (
    <>
      <PageTitle activeMenu="View Order" motherMenu="Order" />
      <div className="card">
        <div className="card-header">
          <div className="content-end">
            <Button
              className="me-2"
              variant="primary btn-rounded"
              onClick={generatePDF}
            >
              <span className="btn-icon-start text-primary">
                <i className="fa fa-solid fa-file-pdf"></i>
              </span>
              PDF
            </Button>

            <Button
              className="me-2"
              variant="btn btn-danger btn-rounded"
              onClick={handlechanges}
            >
              Back
            </Button>
          </div>
        </div>
      </div>
      <div ref={contentRef}>
        <div className="card">
          <div className="card-header">
            <b>Order ID : {listView.OrderNumber}</b>
            <span className="float-right">
              <strong>Current Status : {listView.OrderStatus} </strong>
            </span>{" "}
          </div>
          <div className="row">
            <div className="col-xl-12 col-xxl-12">
              <div className="card">
                <div className="card-body">
                  <Steps
                    direction="horizontal"
                    size="large"
                    type="inline"
                    icons={horizontalIcons}
                    labelPlacement="vertical"
                  >
                    <Step
                      title="Order Created"
                      description=""
                      status={orderTrackingHORZ.CreatedStatus}
                    />
                    <Step
                      title="Order Assigned"
                      description=" "
                      status={orderTrackingHORZ.AssignedStatus}
                    />

                    <Step
                      title="Order Prepared"
                      status={orderTrackingHORZ.PreparedStatus}
                      description=""
                    />

                    <Step
                      title="Invoice Sent"
                      status={orderTrackingHORZ.InvoiceSentStatus}
                      description=""
                    />
                    <Step
                      title="Payment Received"
                      status={orderTrackingHORZ.PaymentReceivedStatus}
                      description=""
                    />
                    <Step
                      title="Ready to Dispatch"
                      status={orderTrackingHORZ.ReadyToDispatchStatus}
                      description=""
                    />
                    <Step
                      title="Order Dispatched"
                      status={orderTrackingHORZ.OrderDispatchedStatus}
                      description=""
                    />
                  </Steps>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <Row style={{ margin: "0 10px" }}>
          <Col xl="4">
            <Card className="text-white bg-card-fuchsia">
              <Card.Header>
                <Card.Title className="text-white">Client Details</Card.Title>
              </Card.Header>
              <Card.Body>
                <Card.Text>
                  <div>
                    <strong className="text-white">
                      {orderClient.CompanyName}
                    </strong>
                  </div>
                  <div style={{ fontSize: "12px" }}>
                    {orderClient.BillingAddress}
                  </div>
                  <div className="text-white" style={{ fontSize: "12px" }}>
                    {orderClient.BillingCity} , {orderClient.BillingCountryName}
                  </div>
                  <div className="text-white" style={{ fontSize: "12px" }}>
                    Email: {orderClient.EmailID}
                  </div>
                  <div className="text-white" style={{ fontSize: "12px" }}>
                    Phone: {orderClient.ContactNumber}
                  </div>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col xl="4">
            <Card className="text-white bg-light-blue">
              <Card.Header>
                <Card.Title className="text-white">Billing Address</Card.Title>
              </Card.Header>
              <Card.Body>
                <Card.Text>
                  <div>
                    <strong>{orderClient.CompanyName}</strong>{" "}
                  </div>
                  <div style={{ fontSize: "12px" }}>
                    {orderClient.BillingAddress}
                  </div>
                  <div style={{ fontSize: "12px" }}>
                    {orderClient.BillingCity} , {orderClient.BillingCountryName}
                  </div>
                  <div style={{ fontSize: "12px" }}>
                    Email: {orderClient.EmailID}
                  </div>
                  <div style={{ fontSize: "12px" }}>
                    Phone: {orderClient.ContactNumber}
                  </div>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col xl="4">
            <Card className="text-white bg-light-green">
              <Card.Header>
                <Card.Title className="text-white">Shipping Address</Card.Title>
              </Card.Header>
              <Card.Body>
                <Card.Text>
                  <div>
                    <strong>{orderClient.CompanyName}</strong>
                  </div>
                  <div className="card-text" style={{ fontSize: "12px" }}>
                    {state.ShippingAddress}
                  </div>
                  <div className="card-text">
                    {state.ShippingCity}
                    {state.ShippingCity === "" ? "" : ","}
                    {state.CountryName}
                  </div>
                  <div className="card-text" style={{ fontSize: "12px" }}>
                    Email: {orderClient.EmailID}
                  </div>
                  <div className="card-text" style={{ fontSize: "12px" }}>
                    Phone: {orderClient.ContactNumber}
                  </div>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row> */}
        <Row style={{ margin: "0 10px" }}>
          <Col xl="4">
            <Card className="text-white bg-card-fuchsia">
              <Card.Header>
                <Card.Title className="text-white">Client Details</Card.Title>
              </Card.Header>
              <Card.Body>
                <div>
                  {" "}
                  {/* Use a <div> instead of <Card.Text> */}
                  <div>
                    <strong className="text-white">
                      {orderClient.CompanyName}
                    </strong>
                  </div>
                  <div style={{ fontSize: "12px" }}>
                    {orderClient.BillingAddress}
                  </div>
                  <div className="text-white" style={{ fontSize: "12px" }}>
                    {orderClient.BillingCity}, {orderClient.BillingCountryName}
                  </div>
                  <div className="text-white" style={{ fontSize: "12px" }}>
                    Email: {orderClient.EmailID}
                  </div>
                  <div className="text-white" style={{ fontSize: "12px" }}>
                    Phone: {orderClient.ContactNumber}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xl="4">
            <Card className="text-white bg-light-blue">
              <Card.Header>
                <Card.Title className="text-white">Billing Address</Card.Title>
              </Card.Header>
              <Card.Body>
                <div>
                  <div>
                    <strong>{orderClient.CompanyName}</strong>
                  </div>
                  <div style={{ fontSize: "12px" }}>
                    {orderClient.BillingAddress}
                  </div>
                  <div style={{ fontSize: "12px" }}>
                    {orderClient.BillingCity}, {orderClient.BillingCountryName}
                  </div>
                  <div style={{ fontSize: "12px" }}>
                    Email: {orderClient.EmailID}
                  </div>
                  <div style={{ fontSize: "12px" }}>
                    Phone: {orderClient.ContactNumber}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xl="4">
            <Card className="text-white bg-light-green">
              <Card.Header>
                <Card.Title className="text-white">Shipping Address</Card.Title>
              </Card.Header>
              <Card.Body>
                <div>
                  <div>
                    <strong>{orderClient.CompanyName}</strong>
                  </div>
                  <div className="card-text" style={{ fontSize: "12px" }}>
                    {state.ShippingAddress}
                  </div>
                  <div className="card-text">
                    {state.ShippingCity}
                    {state.ShippingCity === "" ? "" : ","}
                    {state.CountryName}
                  </div>
                  <div className="card-text" style={{ fontSize: "12px" }}>
                    Email: {orderClient.EmailID}
                  </div>
                  <div className="card-text" style={{ fontSize: "12px" }}>
                    Phone: {orderClient.ContactNumber}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <div className="card">
          <OrderDatatable orderId={listView.OrderID} isPriceWrap={true} />
          <div className="row mb-12">
            <div style={{ marginLeft: 60 }}>
              <Steps
                style={{ color: "black" }}
                direction="vertical"
                icons={verticalIcons}
                size="large"
              >
                {orderStatusHistoryUniqueList &&
                  orderStatusHistoryUniqueList.length > 0 &&
                  orderStatusHistoryUniqueList.map((inputField, index) => (
                    <Step
                      key={`${inputField}~${index}`}
                      style={{ maxWidth: 700 }}
                      title={`${inputField.OrderStatusName === "Invoice Sent" ? "Invoice Status Changed" : inputField.OrderStatusName} by ${
                        inputField.UserName
                      } on ${fDate12US(inputField.CreatedDate)}   ${
                        inputField.Message
                      }`}
                      status="finish"
                      description=""
                    />
                  ))}
              </Steps>
            </div>
          </div>
        </div>
      </div>
      {loader}
    </>
  );
};

export default ViewOrder;
